import type { NavItemConfig } from './../../../../types/nav';
import { paths } from './../../../../utils/paths';

export const adminNavItems = [
  { key: 'overview', title: 'Overview', href: paths.admin.home, icon: 'chart-pie' },
  { key: 'users', title: 'Businesses', href: paths.admin.users, icon: 'users' },
  { key: 'companies', title: 'Companies', href: paths.admin.companies, icon: 'company' },
  { key: 'agents', title: 'Agents', href: paths.admin.agents, icon: 'agent' },
  { key: 'assessments', title: 'Assessments', href: paths.admin.assessment, icon: 'assessment' },
  { key: 'programs', title: 'Programs', href: paths.admin.program, icon: 'program' },
  { key: 'tasks', title: 'Workflows & Tasks', href: paths.admin.workflows, icon: 'tasks' },
  { key: 'activities', title: 'Activities', href: paths.admin.activities, icon: 'activity' },
  { key: 'subscriptions', title: 'Subscriptions', href: paths.admin.subscriptions, icon: 'subscription' },
  { key: 'payments', title: 'Invoices', href: paths.admin.payments, icon: 'invoice' },
  { key: 'settings', title: 'Settings', href: paths.admin.settings, icon: 'gear-six' },
  { key: 'profile', title: 'Profile', href: paths.admin.profile, icon: 'user' }
] satisfies NavItemConfig[];
